import { Avatar, MenuItem } from '@material-ui/core'

import styles from '@root-gipro/modules/header/styles/HeaderAvatar.module.scss'
import { DropDown } from '@root-gipro/shared/Windows/DropDown/DropDown'
import { IHeaderAvatarProps } from '@root-gipro/store/interfaces/header'
import React, { useEffect, useState } from 'react'
import { roleTitleById } from '@root-gipro/modules/admin/models/roles'

const HeaderAvatar: React.FC<IHeaderAvatarProps> = ({ logout }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

	const [userInfo, setUserInfo] = useState<string>('')

	useEffect(() => {
		const roleId = localStorage.getItem('roleId')
		const roleString = (roleId) ? '('+roleTitleById(Number(roleId))+')' : ''
		const firstname = localStorage.getItem('firstname')
		const lastname = localStorage.getItem('lastname')
		setUserInfo(`${lastname} ${firstname} ${roleString}`)
	}, [localStorage.getItem('firstname'), localStorage.getItem('lastname'), localStorage.getItem('roleId')])

	const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
		setAnchorEl(event.currentTarget)
	}
	const downloadUserManual = () => {
		const link = document.createElement('a')
		link.href = '/assets/user-manual.pdf'
		link.download = 'Руководство пользователя.pdf'
		link.click()
		link.remove()
	}

	return (
		<div className={styles.user}>
			{localStorage.getItem('firstname') && localStorage.getItem('lastname') ? (
				<div className={styles.username}>{userInfo}</div>
			) : null}
			<div className={styles.avatar}>
				<Avatar src={'/assets/images/svg/default-avatar.svg'} onClick={handleClick} />
				<DropDown
					anchorEl={anchorEl}
					setAnchorEl={setAnchorEl}
					anchorOrigin={{
						vertical: 43,
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
				>
					<MenuItem onClick={downloadUserManual}>Руководство пользователя</MenuItem>
					<MenuItem onClick={() => logout()}>Выйти</MenuItem>
				</DropDown>
			</div>
		</div>
	)
}

export default HeaderAvatar
